import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import ResourceDocumentView from '../views/ResourceDocumentView.vue';
import LoginView from '../views/LoginView.vue';
import TokenView from '../views/TokenView.vue';
import UnauthorizedView from '../views/UnauthorizedView.vue';
import LogoutView from '../views/LogoutView.vue';

import store from '../store';

const loginRedirect = async ({ next }, allowedRoles) => {
  // check login status
  store.dispatch('userStore/checkLogin');
  if (!store.getters['userStore/isAuthenticated']) {
    return next({ name: 'login' });
  }
  const isAllowed = await store.dispatch('userStore/hasRole', allowedRoles);
  if (allowedRoles && !isAllowed) {
    // eslint-disable-next-line no-alert
    alert('Unauthorized to view the selected resource.');
    // eslint-disable-next-line consistent-return
    return;
  }

  return next();
};

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    beforeEnter: (to, from, next) => {
      if (to.query.code) {
        next({ name: 'login', query: to.query });
        return;
      }
      loginRedirect({ to, from, next }, ['3B0DFFAE-FF08-425D-824D-859F6917B98E',
        '052632C0-EACD-4655-B8CC-C99F1CBA32BC',
        'B305332E-FC85-4C82-82AE-D57A70E0F0A7']);
    },
  },
  {
    path: '/resources',
    name: 'resources',
    component: ResourceDocumentView,
    beforeEnter: (to, from, next) => {
      loginRedirect({ to, from, next }, ['3B0DFFAE-FF08-425D-824D-859F6917B98E',
        '052632C0-EACD-4655-B8CC-C99F1CBA32BC',
        '37430222-7D42-4132-92E5-F1082FC3FD35']);
    },
  },
  {
    path: '/Login',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/Token',
    name: 'token',
    component: TokenView,
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: UnauthorizedView,
  },
  {
    path: '/logout',
    name: 'logout',
    component: LogoutView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes,
  base: process.env.VUE_APP_BASE_URL,
  sensitive: false,
});

export default router;
